webpackJsonp([257680017402065],{

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ahbgroup.5eae14c0.jpg";

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/values.b7dc329f.jpg";

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _ahbgroup = __webpack_require__(132);
	
	var _ahbgroup2 = _interopRequireDefault(_ahbgroup);
	
	var _values = __webpack_require__(135);
	
	var _values2 = _interopRequireDefault(_values);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Generic = function Generic(props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                'Valores'
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: 'AH Business Group' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { id: 'main', className: 'alt' },
	            _react2.default.createElement(
	                'section',
	                { id: 'one' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        'header',
	                        { className: 'major' },
	                        _react2.default.createElement(
	                            'h8',
	                            null,
	                            'Os nossos valores'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'image main' },
	                        _react2.default.createElement('img', { src: _values2.default, alt: '' })
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        ' Assumindo um elevado compromisso com as Pessoas, e fortemente alicer\xE7ada na ',
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            'transpar\xEAncia'
	                        ),
	                        ' das suas rela\xE7\xF5es internas e externas, a Gest\xE3o de Pessoas da AHB valoriza, fruto do empreendedorismo que est\xE1 na origem deste grupo empresarial, o esp\xEDrito de iniciativa e a ',
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            'confian\xE7a'
	                        ),
	                        ' nas capacidades de gest\xE3o.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        ' Com o foco no desenvolvimento individual de compet\xEAncias orientado para a pretendida progress\xE3o na carreira, e por acreditar que em cada colaborador existe um potencial capaz de se traduzir em renovadas compet\xEAncias, privilegia o recrutamento interno e apoia a evolu\xE7\xE3o pessoal e profissional de cada colaborador.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        ' Por considerar que os seus recursos humanos representam a primordial e mais importante energia das suas empresas, promove e apoia o seu crescimento dentro da organiza\xE7\xE3o alinhando objetivos institucionais e pessoais numa sinergia de elevado valor acrescentado s\xF3 poss\xEDvel com uma gest\xE3o integrada e crente na motiva\xE7\xE3o como ponto de partida para os consequentes resultados.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        ' Acreditando na ',
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            'competitividade'
	                        ),
	                        ' no curto e m\xE9dio prazos, assente no profissionalismo e rigor dos seus colaboradores, e da vontade de estes se superarem a cada dia, a AHB continuar\xE1 a apostar na excel\xEAncia das suas Pessoas na sua busca por mais e melhores resultados.'
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Generic;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-values-js-b2fabd400d00abd1862f.js